import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const WaterLeakDetectionPost = lazy(() => import('../pages/blog/posts/WaterLeakDetection'));
const PreventWaterDamagePost = lazy(() => import('../pages/blog/posts/PreventWaterDamage'));
const WinterizingFrozenPipesPost = lazy(() => import('../pages/blog/posts/WinterizingFrozenPipes'));
const FloodCleanupPage = lazy(() => import('../pages/services/flood-cleanup/page'));
const MoldRemovalPage = lazy(() => import('../pages/services/mold-removal/page'));
const OdorRemovalPage = lazy(() => import('../pages/services/odor-removal/page'));
const SewageCleanupPage = lazy(() => import('../pages/services/sewage-cleanup/page'));
const SmokeDamagePage = lazy(() => import('../pages/services/smoke-damage/page'));
const StormDamagePage = lazy(() => import('../pages/services/storm-damage/page'));
const FarmingtonPage = lazy(() => import('../pages/farmington/page'));
const KaysvillePage = lazy(() => import('../pages/kaysville/page'));
const LaytonPage = lazy(() => import('../pages/layton/page'));
const ClearfieldPage = lazy(() => import('../pages/clearfield/page'));
const BountifulPage = lazy(() => import('../pages/bountiful/page'));
const CentervillePage = lazy(() => import('../pages/centerville/page'));
const FruitHeightsPage = lazy(() => import('../pages/fruit-heights/page'));
const SyracusePage = lazy(() => import('../pages/syracuse/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/water-leak-detection',
    element: <WaterLeakDetectionPost />,
  },
  {
    path: '/blog/prevent-water-damage',
    element: <PreventWaterDamagePost />,
  },
  {
    path: '/blog/winterizing-frozen-pipes',
    element: <WinterizingFrozenPipesPost />,
  },
  {
    path: '/services/flood-cleanup',
    element: <FloodCleanupPage />,
  },
  {
    path: '/services/mold-removal',
    element: <MoldRemovalPage />,
  },
  {
    path: '/services/odor-removal',
    element: <OdorRemovalPage />,
  },
  {
    path: '/services/sewage-cleanup',
    element: <SewageCleanupPage />,
  },
  {
    path: '/services/smoke-damage',
    element: <SmokeDamagePage />,
  },
  {
    path: '/services/storm-damage',
    element: <StormDamagePage />,
  },
  {
    path: '/farmington',
    element: <FarmingtonPage />,
  },
  {
    path: '/kaysville',
    element: <KaysvillePage />,
  },
  {
    path: '/layton',
    element: <LaytonPage />,
  },
  {
    path: '/clearfield',
    element: <ClearfieldPage />,
  },
  {
    path: '/bountiful',
    element: <BountifulPage />,
  },
  {
    path: '/centerville',
    element: <CentervillePage />,
  },
  {
    path: '/fruit-heights',
    element: <FruitHeightsPage />,
  },
  {
    path: '/syracuse',
    element: <SyracusePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
